import Swup from "swup";
import FragmentPlugin, { Rule as FragmentRule } from "@swup/fragment-plugin";

const STORAGE_KEY = "projectFilters.view";

/**
 * Define the rules for Fragment Plugin
 */
export const workFilterRules = [
  // Rule 1: Between the various views of the characters list
  {
    from: /^\/work\/?(web\/?|brand\/?|app\/?|\/?)$/,
    to: /^\/work\/?(web\/?|brand\/?|app\/?|\/?)$/,
    containers: ["#projects-grid"],
  },
];

export default {
  init() {
    this.destroy();

    this.toggle = document.getElementById("viewToggle");
    this.projectsGrid = document.getElementById("projects-grid");

    if (!this.toggle) {
      return;
    }
    if (!this.projectsGrid) {
      return;
    }

    this.toggle.checked = localStorage.getItem(STORAGE_KEY) === "list";
    console.log("projectFilters", this.toggle.checked);

    this.handleToggle = this._handleToggle.bind(this);
    this.toggle.addEventListener("change", this.handleToggle);
    this.handleToggle();
  },

  _handleToggle() {
    if (!this.projectsGrid) return;
    this.projectsGrid.classList.toggle("is-list", this.toggle.checked);
    localStorage.setItem(STORAGE_KEY, this.toggle.checked ? "list" : "grid");
  },

  destroy() {
    if (this.toggle && this.handleToggle) {
      this.toggle.removeEventListener("change", this.handleToggle);
    }

    this.toggle = null;
    this.projectsGrid = null;
  },
};
